var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4409 32.2046C25.2775 32.2046 32.4409 25.0411 32.4409 16.2046C32.4409 7.36802 25.2775 0.20459 16.4409 0.20459C7.60435 0.20459 0.440918 7.36802 0.440918 16.2046C0.440918 25.0411 7.60435 32.2046 16.4409 32.2046Z",
    fill: "#6AD699"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11394_2225",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7924 5.23828H5.55078V27.4799H27.7924V5.23828Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11394_2225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1862 7.23734V24.1794C25.1862 24.4427 25.0274 24.6802 24.7839 24.7814C24.5299 24.8853 24.254 24.8205 24.0734 24.6405C24.0257 24.5922 19.337 20.0623 14.6735 19.6581V11.7593C19.345 11.3557 24.0257 6.82452 24.0734 6.77688C24.2606 6.59032 24.5398 6.53274 24.7839 6.63529C24.903 6.68491 25.0049 6.76827 25.0763 6.87545C25.1478 6.98263 25.1862 7.10833 25.1862 7.23734ZM27.7928 15.7084C27.7928 16.6716 27.2675 17.5138 26.4895 17.965V13.4517C27.2675 13.9029 27.7928 14.7451 27.7928 15.7084ZM15.6659 23.2604C15.7267 23.1777 15.7671 23.0818 15.783 22.9806C15.7995 22.8793 15.7916 22.7755 15.7605 22.6776C15.5779 22.106 15.4528 21.5667 15.3853 21.0725C14.9441 20.9845 14.5021 20.927 14.0641 20.9243C14.1032 21.3365 14.1673 21.7659 14.2792 22.2244H13.3119C13.1776 21.8102 13.0512 21.3769 12.9527 20.9211H9.46079C9.28415 20.9211 9.11743 20.8866 8.94542 20.8694C9.2729 23.4536 10.1144 25.6137 10.1588 25.7242C10.2071 25.8453 10.2904 25.9491 10.3983 26.0219C10.5061 26.0954 10.6338 26.1344 10.7635 26.1344H14.0218C14.5279 26.1344 14.8409 25.5806 14.5802 25.1479C14.5723 25.1341 14.2018 24.4917 13.7955 23.5277H15.1399C15.2424 23.5277 15.3437 23.5039 15.435 23.4569C15.5263 23.4106 15.6057 23.3431 15.6659 23.2604ZM9.46079 19.6184H13.3701V11.799H9.46079C7.30466 11.799 5.55078 13.5522 5.55078 15.7084C5.55078 17.8645 7.30466 19.6184 9.46079 19.6184Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.1e6cd8da2226de98e5eb94f8b2d364e2.svg";
export { ForwardRef as ReactComponent };